import React from "react";
import moment from "moment";
import NullableValue from "../../../../../Utils/renderField/nullableValue";
const verIcon = require("assets/img/icons/ver.png");
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const AlmacenesPadreTable = ({
    almacenesPadre,
    EliminarAlmacenPadre,
    SeleccionarAlmacenEdicion,
}) => {
    return (
        <div className="new-table-wrapper almacenes-padre__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Acopio</th>
                        <th>Fecha de creación</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {almacenesPadre.length === 0 && (
                        <tr>
                            <td colSpan={4} className="text-center">
                                No hay almacenes padre para mostrar
                            </td>
                        </tr>
                    )}
                    {almacenesPadre.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center">{item.nombre}</td>
                                <td className="text-center">
                                    {item.acopio ? item.acopio.nombre : ""}
                                </td>
                                <td className="text-center">
                                    <NullableValue value={item.creado}>
                                        {moment(item.creado).format(
                                            "DD/MM/YYYY HH:mm",
                                        )}
                                    </NullableValue>
                                </td>
                                <td className="text-center">
                                    <div className="table-actions">
                                        <img
                                            src={editarIcon}
                                            alt="Editar"
                                            className="action_img"
                                            title="Editar"
                                            onClick={() =>
                                                SeleccionarAlmacenEdicion(item)
                                            }
                                        />
                                        <img
                                            src={eliminarIcon}
                                            alt="Eliminar"
                                            className="action_img"
                                            title="Eliminar"
                                            onClick={() =>
                                                EliminarAlmacenPadre(item.id)
                                            }
                                        />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
